import { globalGetService } from '@/utils/globalApiServices';
import { Pagination } from '@/utils/types';
import { BillingReport } from './types';

export const getBillingReports = async (params = {}) => {
  const response = await globalGetService('csp/finance/invoice', {
    ...params,
  });
  return response?.ok
    ? (response.data as Pagination<BillingReport>)
    : undefined;
};

export const downloadBillingReport = async (month: string) => {
  const response = await globalGetService(
    `csp/finance/invoice/month/${month}/csv`,
    {},
    'arraybuffer'
  );

  return response?.ok ? (response.data as ArrayBuffer) : undefined;
};
